import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import styles from './index.scss';
import PromoButton from './PromoButton';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

const Footer = ({
  cartData,
  isPromoCodeInputVisable,
  isTrial,
  promotionApplied,
  onToggleShowPromoCodeInput,
  handleRemovePromoCode,
  handleTogglePricingDetails,
  showPricingDetails
}) => {
  return (
    <div className={styles.summaryFooter}>
      <div className={styles.billedToday}>
        <div className={styles.billed}>
          <strong>{I18n.t(`${I18nPrefix}.billed_today`)}</strong>
        </div>
        <div className={styles.billedTotal}>
          <strong>
            {Cldr.formatCurrency(cartData.billedToday, cartData.currency)}
          </strong>
        </div>
      </div>
      <div className={styles.footerActions}>
        <button className="btn btn-link" onClick={handleTogglePricingDetails}>
          {I18n.t(
            `${I18nPrefix}.cta.${
              showPricingDetails
                ? 'hide_pricing_details'
                : 'show_pricing_details'
            }`
          )}
        </button>
        {!isTrial && (
          <>
            <span className={styles.actionDivider}>·</span>
            <PromoButton
              promotionApplied={promotionApplied}
              isPromoCodeInputVisable={isPromoCodeInputVisable}
              onToggleShowPromoCodeInput={onToggleShowPromoCodeInput}
              handleRemovePromoCode={handleRemovePromoCode}
            />
          </>
        )}
      </div>
    </div>
  );
};

Footer.propTypes = {
  promotionApplied: PropTypes.bool.isRequired,
  // TODO: udpate this to use shared cartData after refactor
  cartData: PropTypes.shape({
    billedToday: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired
  }).isRequired,
  isPromoCodeInputVisable: PropTypes.bool.isRequired,
  isTrial: PropTypes.bool.isRequired,
  onToggleShowPromoCodeInput: PropTypes.func.isRequired,
  handleRemovePromoCode: PropTypes.func.isRequired,
  handleTogglePricingDetails: PropTypes.func.isRequired,
  showPricingDetails: PropTypes.bool.isRequired
};

export default Footer;
